export const CHROME_EXTENSION_URL =
  'https://chromewebstore.google.com/detail/cosupport-ai/kcpfdjeibdkkalafhdfjicjkcealkkhc';

export const PIPE_DRIVE = {
  TOKEN: '03ae01f2fcdb2eb53f804dea1b2951db30902bb4', //58807cb577a329c9c043d4b047d18fe0713aec74
  URL: 'https://api.pipedrive.com/v1',
};
export const MAILCHIMP = {
  API_KEY: 'df280b42c14b1526ad891175e3b7b98c',
  SERVER: 'us10',
  LIST_ID: 'c4a9a3f4f8',
};

export const EMAIL = {
  SMTP_HOST: 'smtp.ukr.net',
  SMTP_PORT: 465,
  AUTH: {
    USERNAME: '3dv_zendesk@ukr.net',
    PASSWORD: 'Sc3nf6Zu5uxHOauZ',
  },
  MESSAGE: {
    FROM: 'website@cosupport.ai',
    TO: 'welcome@cosupport.ai',
    SUBJECT: 'New Lead form cosupport.ai demo page.',
    TEXT: 'Plaintext version of the message',
    HTML: '<p>HTML version of the message</p>',
  },
};

export const CALENDLY_WIDGET = {
  DATA_URL: 'https://calendly.com/cosupport-alex/cosupport?hide_gdpr_banner=1',
  SCRIPT_SRC: 'https://assets.calendly.com/assets/external/widget.js',
};

export const LINKS_DO_FOLLOW_WHITE_LIST = [
  'https://quidget.ai',
  'https://www.aidbase.ai',
  'https://www.jam.co.uk',
];
